import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Context } from '@components/Context';
import { H3 } from '@components/dashboard/Typography';
import ProductBox from '@components/storefront/ProductBox';
import { CartItem } from '@contracts';
import { ProductData } from '@data/storefront';
import { viewItemListTrack } from '@utils/tracking';

interface Props {
  data: ProductData[];
  onlyPriority?: boolean;
}

const ProductCatalogue: React.FC<Props> = ({ data, onlyPriority = false }) => {
  if (!data) return null;
  const { state } = useContext(Context);
  const { firebaseAuth } = state;
  const [products, setProducts] = useState<CartItem[]>([]);

  const handleProductTracking = (cartItem: CartItem) => {
    setProducts((prevProducts) => [...prevProducts, cartItem]);
  };

  useEffect(() => {
    if (!firebaseAuth) return;
    handleViewListTracking();
  }, [products, firebaseAuth]);

  const handleViewListTracking = async () => {
    const userEmail = firebaseAuth?.currentUser?.email ?? '';
    if (products.length === data.length) {
      const trackingData = products.map((product) => ({
        ...product,
        id: typeof product.id === 'string' ? product.id : product.id.text,
        productCode: typeof product.productCode === 'string' ? product.productCode : product.productCode.text
      }));
      viewItemListTrack(trackingData, userEmail);
    }
  };

  if (data.length === 0) {
    return (
      <NoProductsContainer>
        <H3>No products found, please choose a different category</H3>
      </NoProductsContainer>
    );
  }
  return (
    <Container>
      {data.map((product, index) => {
        if (onlyPriority && product.priority) {
          return <ProductBox data={product} key={index} handleTracking={(cartItem) => handleProductTracking(cartItem)} />;
        }
        if (!onlyPriority) {
          return <ProductBox data={product} key={index} handleTracking={(cartItem) => handleProductTracking(cartItem)} />;
        }
        return <></>;
      })}
    </Container>
  );
};

export default ProductCatalogue;

const NoProductsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto 120px;
  width: 100%;

  h3 {
    width: 100%;
    text-align: center;
  }

  @media (max-width: 820px) {
    margin-bottom: 60px;
  }
`;

const Container = styled.div`
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto 120px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;

  @media (max-width: 1240px) {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;
    padding: 0 30px;
  }

  @media (max-width: 820px) {
    grid-template-columns: 1fr 1fr;
    gap: 19px;
    padding: 0 20px;
    margin-bottom: 60px;
  }

  & .product-box-container {
    width: auto;
  }
`;
